import { render, staticRenderFns } from "./question.vue?vue&type=template&id=7b598542&"
import script from "./question.vue?vue&type=script&lang=ts&"
export * from "./question.vue?vue&type=script&lang=ts&"
import style0 from "./question.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports